module.exports = __webpack_public_path__ + "static/one-22360ccace0d3cf161e852204bac4ffc.jpg";